<div class="flex flex-col gap-4">
  <h2 mat-dialog-title>Crea dossier</h2>

  <div mat-dialog-content class="flex min-w-[400px] flex-col gap-4 !p-4">
    <mat-form-field class="w-full" appearance="outline" floatLabel="always">
      <mat-label>Nome dossier</mat-label>
      <input
        matInput
        [(ngModel)]="dossierName"
        placeholder="Inserisci il nome del dossier"
      />
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end" class="gap-2">
    <button mat-button (click)="onSave()" [disabled]="!dossierName().trim()">
      Salva
    </button>
    <button mat-button (click)="onCancel()" class="button-grey">Annulla</button>
  </div>
</div>
